module.exports = __webpack_public_path__ + "UX3.png?f5b89f83cd194afee004e3e1edbfab46";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX3.png
// module id = 79
// module chunks = 0